import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/Login.vue'
import DashboardLayout from '../components/DashboardLayout.vue'
import WindowSettings from '../views/WindowSettings.vue'
import ScriptConfig from '../views/ScriptConfig.vue'
import CreateConfigYmirKorea from '../views/CreateConfigYmirKorea.vue'
import CreateConfigYmirInternational from '../views/CreateConfigYmirInternational.vue'
import ConfigEditorWrapper from '../views/ConfigEditorWrapper.vue'
import DataStats from '../views/DataStats.vue'
import UserManagement from '../views/UserManagement.vue'
import UserOperationLogs from '../views/UserOperationLogs.vue'
import APKManagement from '../views/APKManagement.vue'
import ItemManagement from '../views/ItemManagement.vue'
import TeamManagement from '../views/TeamManagement.vue'
import Statistics from '../views/Statistics.vue'
import GameConstantsManagement from '../views/GameConstantsManagement.vue'
import ItemPriceStatistics from '../views/ItemPriceStatistics.vue'
import NannyStats from '../views/NannyStats.vue'
import ActivityCraftManagement from '../views/ActivityCraftManagement.vue'

// 根据用户游戏类型获取对应的配置组件
// 如果是编辑模式，会根据配置的game字段动态选择，这里只是默认值
const getConfigComponent = () => {
  try {
    const userInfo = JSON.parse(localStorage.getItem('user') || '{}')
    const game = userInfo.game || '尤弥尔传奇韩服'
    
    if (game === '尤弥尔传奇国际服') {
      return CreateConfigYmirInternational
    } else {
      return CreateConfigYmirKorea
    }
  } catch (error) {
    console.error('获取用户游戏类型失败:', error)
    return CreateConfigYmirKorea
  }
}

// 根据配置的游戏类型获取对应的配置组件
const getConfigComponentByGame = (game) => {
  if (game === '尤弥尔传奇国际服') {
    return CreateConfigYmirInternational
  } else {
    return CreateConfigYmirKorea
  }
}

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresGuest: true // 需要未登录状态
    }
  },
  {
    path: '/dashboard',
    component: DashboardLayout,
    meta: {
      requiresAuth: true // 需要登录状态
    },
    children: [
      {
        path: '',
        redirect: to => {
          const user = localStorage.getItem('user')
          if (user) {
            try {
              const parsedUser = JSON.parse(user)
              // 根据用户类型重定向
              if (parsedUser.is_admin === 1 || parsedUser.is_admin === 2) {
                // 超级管理员和代理都进入用户管理
                return '/dashboard/users'
              } else {
                // 普通用户和配置管理员进入窗口设置
                return '/dashboard/windows'
              }
            } catch {
              return '/dashboard/windows'
            }
          }
          return '/dashboard/windows'
        }
      },
      {
        path: 'windows',
        name: 'WindowSettings',
        component: WindowSettings,
        meta: { mobileLayout: 'fill' }
      },
      {
        path: 'scripts',
        name: 'ScriptConfig',
        component: ScriptConfig
      },
      {
        path: 'scripts/create',
        name: 'CreateConfig',
        component: () => Promise.resolve(getConfigComponent())
      },
      {
        path: 'scripts/edit/:id',
        name: 'EditConfig',
        component: ConfigEditorWrapper,
        props: true
      },
      {
        path: 'data-stats',
        name: 'DataStats',
        component: DataStats
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: UserManagement
      },
      {
        path: 'users/operation-logs',
        name: 'UserOperationLogs',
        component: UserOperationLogs
      },
      {
        path: 'apk',
        name: 'APKManagement',
        component: APKManagement
      },
      {
        path: 'items',
        name: 'ItemManagement',
        component: ItemManagement
      },
      {
        path: 'teams',
        name: 'TeamManagement',
        component: TeamManagement
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: Statistics
      },
      {
        path: 'game-constants',
        name: 'GameConstantsManagement',
        component: GameConstantsManagement
      },
      {
        path: 'item-price-statistics',
        name: 'ItemPriceStatistics',
        component: ItemPriceStatistics
      },
      {
        path: 'nanny-stats',
        name: 'NannyStats',
        component: NannyStats
      },
      {
        path: 'activity-craft',
        name: 'ActivityCraftManagement',
        component: ActivityCraftManagement
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const isLoggedIn = !!token

  // 需要登录的页面
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login')
    return
  }

  // 需要未登录状态的页面（如登录页）
  if (to.meta.requiresGuest && isLoggedIn) {
    next('/dashboard')
    return
  }

  // 权限检查
  if (isLoggedIn && to.path.startsWith('/dashboard')) {
    try {
      const userInfo = JSON.parse(localStorage.getItem('user') || '{}')

      // 代理可以访问用户管理页面、操作日志页面和物价统计页面
      if (userInfo.is_admin === 2) {
        const allowedPaths = ['/dashboard', '/dashboard/users', '/dashboard/users/operation-logs', '/dashboard/item-price-statistics', '/dashboard/nanny-stats']
        if (!allowedPaths.includes(to.path)) {
          next('/dashboard/users')
          return
        }
      }
    } catch (error) {
      console.error('解析用户信息失败:', error)
    }
  }

  next()
})

export default router 